exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-form{z-index:30}.file-form .form-body{padding:0}", ""]);

// exports
